module.exports = __webpack_public_path__ + "img/questions-learn-more.6dd54ccb.svg";